import { clsx } from "clsx";
import { type FC, useContext, useState } from "react";

import { SymbolIcon } from "widgets";
import { useHotKeys } from "widgets/hooks";

import style from "./styles/NavigationPanel.module.scss";

import { FullscreenContext } from "../../../app_context.js";
import { type ILicensable } from "../../../redux/modules/config.js";
import { Hotkeys } from "../../../settings/hotkeys.js";
import ContextWidget, { type INavigationContextProps } from "./ContextWidget.js";
import NavigationCategory from "./NavigationCategory.js";
import { type IRouteNavItemProps } from "./RouteNavItem.js";

// --- Navigation Panel
export interface INavPanelCategory extends ILicensable {
  label?: string;
  badge?: string;
  tooltip?: string;
  widget?: JSX.Element; // ButtonWidget, PaginationWidget, ...
  navItems: IRouteNavItemProps[];
  forceCollapsed?: boolean;
  eventKey?: string; // useful for generic behavior like Content Browser, TODO rename to "key" or "id" or even "payload" object
  isLoading?: boolean;
}

interface INavigationPanelProps {
  navPanelCategories: INavPanelCategory[];
  contextWidgetProps?: INavigationContextProps;
  isCollapsed?: boolean;
  tipTourId?: string;
}

const NavigationPanel: FC<INavigationPanelProps> = (props) => {
  const [isCollapsed, setCollapsed] = useState<boolean>(Boolean(props.isCollapsed));
  const notCollapsible = props.navPanelCategories.length < 2;
  const [isFullscreen] = useContext(FullscreenContext);

  useHotKeys(Hotkeys.navigationPanel.collapse, () => setCollapsed(!isCollapsed));

  if (isFullscreen) return null;

  return (
    <div className={clsx(style.panel, { [style.panel_collapsed]: isCollapsed })}>
      <div className={style.bar}>
        {props.contextWidgetProps && (
          <div className={style.bar_group}>
            <ContextWidget {...props.contextWidgetProps} />
          </div>
        )}
        <div className={style.bar_group_bottom}>
          <button onClick={() => setCollapsed(!isCollapsed)} className={style.toggle_button}>
            <SymbolIcon icon={isCollapsed ? "left_panel_open" : "left_panel_close"} filled={!isCollapsed} />
          </button>
        </div>
      </div>
      {!isCollapsed && (
        <div className={style.list}>
          {props.tipTourId && (
            <span id={props.tipTourId} className="hotspot-beacon" style={{ transform: "translate(0px, 25px)" }} />
          )}
          <nav className={style.nav}>
            {/*<div className={style.title}>{props.title}</div>*/}
            {props.navPanelCategories.map((navCategory) => (
              <NavigationCategory
                navCategory={navCategory}
                key={navCategory.label}
                notCollapsible={notCollapsible}
                isLoading={navCategory.isLoading}
              />
            ))}
          </nav>
        </div>
      )}
    </div>
  );
};

export { NavigationPanel };
